import { render } from "./CardIcons.vue?vue&type=template&id=32899af8"
import script from "./CardIcons.vue?vue&type=script&lang=js"
export * from "./CardIcons.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CardIcons.vue?vue&type=style&index=0&id=32899af8&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__